import { useForm } from "@tellescope/forms";
import { NON_ADMIN_ROLE, TellescopeModelFromName } from "@tellescope/tanstack-query";

export const useEditUserForm = (user?: TellescopeModelFromName<"users">) =>
  useForm({
    fields: {
      email: {
        type: "email",
        initialValue: user?.email,
      },
      fname: {
        type: "text",
        initialValue: user?.fname,
      },
      lname: {
        type: "text",
        initialValue: user?.lname,
      },
      internalDisplayName: {
        type: "text",
        initialValue: user?.internalDisplayName,
      },
      displayName: {
        type: "text",
        initialValue: user?.displayName,
      },
      defaultLocationId: {
        type: "select",
        initialValue: user?.defaultLocationId,
      },
      hideFromCalendarView: {
        type: "checkbox",
        initialValue: user?.hideFromCalendarView,
      },
      canvasId: {
        type: "text",
        initialValue: user?.canvasId,
      },
      careTeamRole: {
        type: "text",
        initialValue: user?.careTeamRole,
      },
      pauboxEmail: {
        type: "email",
        initialValue: user?.pauboxEmail,
      },
      phone: {
        type: "phone",
        initialValue: user?.phone,
      },
      url: {
        type: "text",
        initialValue: user?.url,
      },
      suffixes: {
        type: "multiselect",
        initialValue: user?.suffixes ?? [],
      },
      bio: {
        type: "textarea",
        initialValue: user?.bio,
      },
      emailSignature: {
        type: "textarea",
        initialValue: user?.emailSignature,
      },
      NPI: {
        type: "text",
        initialValue: user?.NPI,
      },
      DEA: {
        type: "text",
        initialValue: user?.DEA,
      },
      TIN: {
        type: "text",
        initialValue: user?.TIN,
      },
      disableTicketAutoAssignment: {
        type: "checkbox",
        initialValue: user?.disableTicketAutoAssignment,
      },
      ticketAssignmentPriority: {
        type: "number",
        initialValue: user?.ticketAssignmentPriority ?? 5,
      },
      requireSSO: {
        type: "multiselect",
        initialValue: user?.requireSSO ?? [],
      },
      roles: {
        type: "select",
        initialValue: user?.roles?.[0] ?? NON_ADMIN_ROLE,
      },
      accountType: {
        type: "select",
        initialValue: user?.accountType,
      },
      availableFromNumbers: {
        type: "multiselect",
        initialValue: user?.availableFromNumbers ?? [],
      },
      lockedOutUntil: {
        type: "number",
        initialValue: user?.lockedOutUntil ?? -1,
      },
    },
  });

export type EditUserForm = ReturnType<typeof useEditUserForm>;
